import { memo } from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import Icon from '@ant-design/icons';
import { homeURL } from '$src/constants/urls';
import getEnvironment from '$src/utils/enviroment';
import logo from '$src/assets/icons/ring-logo.svg';

import './index.less';

function Logo({ fontSize = 24, className }) {
  return (
    <a href={homeURL[getEnvironment()]} className={cx('logo', className)} style={{ fontSize }}>
      <Icon className="auth-block__ring-logo-header" component={logo} />
    </a>
  );
}

Logo.propTypes = {
  logoName: PropTypes.string,
  version: PropTypes.string.isRequired,
  fontSize: PropTypes.number,
  className: PropTypes.string,
  includeVersion: PropTypes.bool,
};

export default memo(Logo);
